module.exports = __webpack_public_path__ + "img/smart-city.0922ba52.png";